'use client'

import { AdResponse } from '@/app/util/ads-endpoint'
import { Banner } from '@/app/util/banner'
import { createContext } from 'react'

export type AdsContextProps = {
    htlAds: string[]
    isHTLAdEnabled: (unitName: string) => boolean
    isAnyAdEnabled: () => boolean
    pageName?: string
    adClientData?: AdResponse
    adServerData?: AdResponse
    banner?: Banner
    hasTopLeaderboardAd?: boolean
}

const AdsContext = createContext({
    htlAds: [],
    banner: undefined,
    isAnyAdEnabled: () => false,
    isHTLAdEnabled: () => false,
    pageName: undefined,
    adClientData: undefined,
    adServerData: undefined,
} as AdsContextProps)

export default AdsContext
